import { Check } from "lucide-react";

/**
 * SingleSelectInput — large tap-target option cards.
 * Pure renderer: only displays what `options` provides; emits selected key.
 */
export default function SingleSelectInput({ question, value, onChange }) {
  return (
    <div className="space-y-3" data-testid={`q-${question.id}-options`}>
      {question.options?.map((opt) => {
        const selected = value === opt.key;
        return (
          <button
            type="button"
            key={opt.key}
            onClick={() => onChange(opt.key)}
            data-testid={`q-${question.id}-opt-${opt.key}`}
            className={`kcis-option w-full text-left px-5 py-4 sm:px-6 sm:py-5 flex items-start gap-3 ${
              selected ? "kcis-option--selected" : ""
            }`}
          >
            <span
              aria-hidden
              className={`mt-0.5 shrink-0 rounded-full border h-5 w-5 flex items-center justify-center transition ${
                selected ? "bg-purple-900 border-purple-900 text-white" : "border-slate-300"
              }`}
            >
              {selected && <Check className="h-3 w-3" />}
            </span>
            <span className="text-base text-slate-800 leading-relaxed">{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
}
